import { queryOptions } from '@tanstack/react-query';

import { API } from '@/shared/api/modules';

export type PayDeviationBaseline = 'MEDIAN' | 'AVERAGE';

export type GetPayAcrossCareLevelsParams = {
  facilityId: number;
  baseline?: PayDeviationBaseline;
};

export const getPayAcrossCareLevelsQueryOptions = (
  params: GetPayAcrossCareLevelsParams
) =>
  queryOptions({
    queryKey: ['residents', 'pay-across-care-levels', params],
    queryFn: async ({ signal }) => {
      const response = await API.residents.getPayAcrossCareLevels(
        {
          facilityId: params.facilityId,
          baseline: params.baseline || 'MEDIAN',
        },
        { signal }
      );

      return response;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
